import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { Router, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { ClaimComponent } from './claim//claimcontainer/claim.component';
import { ClaimService } from './shared/claimservice';
import { ClaimResolver } from './shared/claim.resolver.service'
import { ClaimHeaderComponent } from './claim/claimheader/claimheader.component'
import { ClaimSidebarComponent } from './claim/claimsidebar/claimsidebar.component'
import { ClaimScreenDetailComponent } from './claim/claimscreendetail/claimscreendetail.component'
import { NativeElementInjectorDirective } from './directives/nativeelementinjector.directive'
import { NgHttpLoaderComponent, pendingRequestsInterceptor$ } from 'ng-http-loader';
import { SearchComponent } from './search/search.component';
import { SearchResultComponent } from './searchresult/searchresult.component';
import { SearchService } from './shared/searchservice';
import { AuthInterceptor } from './shared/auth.interceptor';
import { AgGridModule } from 'ag-grid-angular';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { RouterLinkRendererComponent } from './searchresult/routerlinkrenderer.component'
import {ServiceBase} from './shared/servicebase'
import { AdminService } from './admin/admin.service';
import {CommunicationService} from './shared/communicationservice'
import{TransmitService} from './shared/transmitservice'
import{CreateInfinityClaimService} from './shared/createinfinityclaimservice'
import{StateOrProvincesService} from './shared/stateorprovincesservice'
import{RiskCoveragesService} from './shared/riskcoveragesservice'
import{DocumentService} from './shared/documentservice'
import{LossDetailService} from './shared/lossdetailservice'
import{DatePipe} from '@angular/common'
import { OktaAuthModule, OktaCallbackComponent, OktaAuthGuard } from '@okta/okta-angular';
import { OktaAuth } from '../../node_modules/@okta/okta-auth-js/esm/esm.browser.js';
import { ModalModule } from './common/modal';
import { ReserveCatRendererComponent } from './claim/claimscreendetail/gridcomponents/reservecatrenderer.component';
import { ReserveTypeRendererComponent } from './claim/claimscreendetail/gridcomponents/reservetyperenderer.component';
import { ReserveAmountRendererComponent } from './claim/claimscreendetail/gridcomponents/reserveamountrenderer.component';
import { ReserveProcessRendererComponent } from './claim/claimscreendetail/gridcomponents/reserveprocessrenderer.component';
import { ReserveCoverageRendererComponent } from './claim/claimscreendetail/gridcomponents/reservecoveragerenderer.component';
import { ReserveClaimantRendererComponent } from './claim/claimscreendetail/gridcomponents/reserveclaimantrenderer.component';
import { NewClaimComponent } from './newclaim/newclaim.component';
import { AdminComponent } from './admin/admin.component';
import { CreateNewClaimService } from './shared/createnewclaimservice';
import { SendReportOfLossService } from './shared/sendreportofloss.service';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { SafeResource } from './pipes/safeResource.pipe';
import { SessionService } from './shared/sessionservice';
import { ClaimPolicyService } from './shared/claimpolicyservice';
import { LogService } from './shared/logservice';
import { HistoryService } from './shared/historyservice';
import { SaveTransmitDetailsService } from './shared/savetransmitdetailsservice';
import { ClaimZipCodeService } from './shared/claimzipcodeservice';
import { ZipCodeLookupService } from './shared/zipcodelookupservice';
import { ClaimStatsService } from './shared/claimstatsservice';
import { DashboardResolver } from './shared/dashboard.resolver.service';
import { CharLimitComponent } from './shared/char-limit/char-limit.component';
import { DashboardService } from './shared/dashboardservice';

const oktaAuth = new OktaAuth({
  issuer: 'https://hcc-dev.oktapreview.com/oauth2/aus10iwn7eqUx5HDL0h8', // 'https://hcc-dev.oktapreview.com/oauth2/default',
  redirectUri: 'https://fnoladminuat.tmhcc.com/login/callback',  //'http://localhost:4200/login/callback',
  clientId: '0oazc4d2ghAP4RXD20h7', //'0oa10iwbir3qeMPyo0h8', 
  pkce: false,
  restoreOriginalUri: async (_oktaAuth, originalUri) => {
    window.location.replace(originalUri || '/');
  }
});

ModuleRegistry.registerModules([AllCommunityModule]);


@NgModule({ declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        CounterComponent,
        FetchDataComponent,
        ClaimComponent,
        ClaimHeaderComponent,
        ClaimSidebarComponent,
        ClaimScreenDetailComponent,
        SearchComponent,
        SearchResultComponent,
        NativeElementInjectorDirective,
        RouterLinkRendererComponent,
        ReserveCatRendererComponent,
        ReserveTypeRendererComponent,
        ReserveAmountRendererComponent,
        ReserveProcessRendererComponent,
        ReserveCoverageRendererComponent,
        ReserveClaimantRendererComponent,
        NewClaimComponent,
        PhoneMaskDirective,
        SafeResource,
        AdminComponent,
        CharLimitComponent
    ],
    bootstrap: [AppComponent], imports: [OktaAuthModule.forRoot({ oktaAuth }),
        ModalModule,
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        NgHttpLoaderComponent,
        AgGridModule,
        RouterModule.forRoot([
            { path: 'claim/:id', component: ClaimComponent, resolve: { data: ClaimResolver }, canActivate: [OktaAuthGuard] },
            { path: '', component: SearchComponent, pathMatch: 'full', resolve: { data: DashboardResolver }, canActivate: [OktaAuthGuard] },
            { path: 'searchresult', component: SearchResultComponent, canActivate: [OktaAuthGuard] },
            { path: 'login/callback', component: OktaCallbackComponent, pathMatch: 'full' },
            { path: 'newclaim', component: NewClaimComponent, canActivate: [OktaAuthGuard] },
            { path: 'admin', component: AdminComponent, canActivate: [OktaAuthGuard] }
        ], {})], providers: [
        OktaAuthGuard,
        DatePipe,
        ClaimService,
        ClaimResolver,
        LossDetailService,
        DocumentService,
        SearchService,
        CommunicationService,
        TransmitService,
        CreateInfinityClaimService,
        StateOrProvincesService,
        RiskCoveragesService,
        CreateNewClaimService,
        SendReportOfLossService,
        ClaimPolicyService,
        SessionService,
        LogService,
        HistoryService,
        SaveTransmitDetailsService,
        ClaimZipCodeService,
        ZipCodeLookupService,
        DashboardResolver,
        ClaimStatsService,
        ServiceBase,
        AdminService,
        DashboardService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withXhr(), withInterceptors([pendingRequestsInterceptor$]), withInterceptorsFromDi())
    ] })
export class AppModule { }
